<template>
  <div>
    <div class='h-borderBox height-500'>
      <div class='h-borderTree-content'>
        <div>
          <div class="h-dp-detail-div">{{detailInfo.serviceName}}</div>
          <div v-show="detailShow.description">
            <div class="h-dp-detail-div">应用介绍 </div>
            <div class="h-dp-detail-div"><span>{{detailInfo.description}}</span></div>
          </div>
          <div v-show="detailShow.deliverType">
            <div class="h-dp-detail-div">交付类型 </div>
            <div class="h-dp-detail-div"><span>{{detailInfo.deliverType}}</span> </div>
          </div>
          <div v-show="detailShow.createTime">
            <div class="h-dp-detail-div">上架时间 </div>
            <div class="h-dp-detail-div"><span>{{detailInfo.createTime}}</span></div>
          </div>
          <div v-show="buttonShow" class="h-dp-detail-div-withBtn">
            <button @click="deployFun">部署实例</button>
          </div>
        </div>
      </div>
    </div>
    <CustomDialog ref='singleDeploymentPage' :element='dialog.element.eleSingleDeployment' :styles='dialog.styles' :messages='dialog.messages.eleSingleDeployment'>
      <template v-slot:dialog-content>
        <SingleDeployment ref='singleDeploymentDialog' :formParams='formParamsChart' :opCode='opCode' :tabElements='tabElements'></SingleDeployment>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { EventBus } from '../../plugins/eventBus';
import CustomDialog from '../common/CustomDialog';
import SingleDeployment from './serverManagement/SingleDeployment';
import SubscriberTool from '../subscriberconfig/util/parseFormNew/tools/subscriberTool';

export default {
  name: 'ServerDetailLeft',
  components: {
    CustomDialog,
    SingleDeployment
  },
  props: {
    detailInfo: {
      type: Object,
      default() {
        return {
          serviceName: '',
          description: '',
          deliverType: '',
          createTime: ''
        }
      }
    },
    detailShow: {
      type: Object,
      default() {
        return {
          description: false,
          deliverType: false,
          createTime: false
        }
      }
    },
    buttonShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formParamsChart: {
        modelName: 'chart'
      },
      tabElements: {
        refName: 'xxxxx',
        items: [
        ]
      },
      opCode: 'add',
      dialog: {
        styles: {
          width: '50%',
          height: '90%',
          visible: false,
          zIndex: 1000,
          model: true
        },
        element: {
          eleSingleDeployment: {
            target: this.$refs.deployBtn,
            refName: 'eleSingleDeployment',
            buttonGroup: [
              { click: this.closeSingleDeploymentPage, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } },
              { click: this.closeSingleDeploymentPage, buttonModel: { content: this.$t('UE.ueCancell') } }
            ],
            title: '部署实例',
            isClose: true
          }
        },
        messages: {
          eleSingleDeployment: {
            title: '部署实例'
          }
        }
      }
    };
  },
  methods: {
    closeSingleDeploymentPage() {
      this.$refs.singleDeploymentPage.clear();
      this.$refs.singleDeploymentPage.close();
    },
    deployFun() {
      console.log('===================', this.detailInfo);
      let processName = '';
      if (this.detailInfo.deliverTypeId === 2) { // D项目的helm部署方式
        processName = 'mano';
        this.$refs.singleDeploymentDialog.getEnvironments('5G');

      } else if (this.detailInfo.deliverTypeId === 1) { // poc微服务
        // 获取需要补充的信息
        processName = 'ems_micrpoc';
        this.$refs.singleDeploymentDialog.getEnvironments('DP');

      }
      const params = {
        info: {
          processName: processName,
        },
        vo: {
          subid: this.detailInfo.pkgVersion,
          // 中文 LOCALE === zh 英文 LOCALE === en
          language: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh'
        }
      };
      const $this = this;
      let arrBase = null;
      this.$axios.post('/lte/ems/nf/getParamJson.html', params).then((response) => {
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('closeDetailPage', 'test');
            $this.$refs.singleDeploymentPage.show();

            const res = JSON.parse(response.data.resultVal);
            $this.formParamsChart = res;

            const items = new Array();
            for (let i = 0; i < res.length; i++) {
              items.push({ header: {text: res[i].key}, content: `#${res[i].key}` });
            }
            $this.tabElements.items = items;


            /*const res = JSON.parse(response.data.resultVal)[0].resultVal;

            const sub = new SubscriberTool();
            const resultMap = sub.$devideByGroupBy(res, []);
            arrBase = resultMap.get($this.formParamsChart.modelName);
            $this.formParamsChart = arrBase;*/

            EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
          } else {
            EventBus.$emit('toast', {type: 'warning', content: '部署失败'});
          }
        }
      });
    }
  }
};
</script>
